import { useCustomFetch } from '~/shared/lib/useCustomFetch';
import type { SpeakerDetailDTO } from '~/shared/api/client/events/events.dto';
import {
  CLIENT_API_SPEAKER_DETAIL_URL,
  CLIENT_API_SPEAKER_DETAIL_KEY,
} from '~/shared/api/client/events/events.const';

export async function useSpeakerDetail() {
  const route = useRoute();

  const speakerId = computed(() => Number(route.params.id));

  const { data, status, error } = await useCustomFetch<SpeakerDetailDTO>(
    () => `${CLIENT_API_SPEAKER_DETAIL_URL}${speakerId.value}/`,
    {
      method: 'GET',
      key: `${CLIENT_API_SPEAKER_DETAIL_KEY}_${speakerId.value}`,
    },
  );

  return { data, status, error };
}
